export default __webpack_public_path__ + "static/media/wh_ep1_tutorial_004.0f350542.jpg";